import base from './dev'

base.env = 'sit'
// base.api.host = 'http://192.168.1.230:5100'
// base.api.pythonHost = 'http://192.168.1.230:5000/api'
base.api.host = 'https://wbtest.lingzhuyun.com/java' // java源
base.api.pythonHost = 'https://wbtest.lingzhuyun.com/api' // python源
export default base



// WEBPACK FOOTER //
// ./src/env/sit.js